import {
  // GET GLOBAL PLACES
  GET_GLOBAL_PLACES,
  GET_GLOBAL_PLACES_SUCCESS,
  GET_GLOBAL_PLACES_FAILED,

  // GET MY PLACE
  GET_MY_PLACE,
  GET_MY_PLACE_SUCCESS,
  GET_MY_PLACE_FAILED,

  // GET PLACE TODAY BOOKING
  GET_PLACE_TODAY_BOOKING,
  GET_PLACE_TODAY_BOOKING_SUCCESS,
  GET_PLACE_TODAY_BOOKING_FAILED,

  // GET PLACE DETAIL
  GET_PLACE_DETAIL,
  GET_PLACE_DETAIL_SUCCESS,
  GET_PLACE_DETAIL_FAILED,

  // CLEAR PLACE DETAIL
  CLEAR_PLACE_DETAIL,

  // UPDATE PLACE
  UPDATE_PLACE,
  UPDATE_PLACE_SUCCESS,
  UPDATE_PLACE_FAILED,

  // GET PLACE IMAGES
  GET_PLACE_IMAGES,
  GET_PLACE_IMAGES_SUCCESS,
  GET_PLACE_IMAGES_FAILED,

  // POST PLACE PREVIEW IMAGE
  POST_PLACE_PREVIEW_IMAGE,
  POST_PLACE_PREVIEW_IMAGE_SUCCESS,
  POST_PLACE_PREVIEW_IMAGE_FAILED,

  // POST PLACE IMAGES
  POST_PLACE_IMAGES,
  POST_PLACE_IMAGES_SUCCESS,
  POST_PLACE_IMAGES_FAILED,

  // DELETE PLACE IMAGES
  DELETE_PLACE_IMAGES,
  DELETE_PLACE_IMAGES_SUCCESS,
  DELETE_PLACE_IMAGES_FAILED,

  // POST IMAGES FROM PLACE TO ROOMS
  POST_IMAGES_FROM_PLACE_TO_ROOMS,
  POST_IMAGES_FROM_PLACE_TO_ROOMS_SUCCESS,
  POST_IMAGES_FROM_PLACE_TO_ROOMS_FAILED,

  // UPDATE PLACE IMAGES
  UPDATE_PLACE_IMAGES,

  // RESET PLACE IMAGES
  RESET_PLACE_IMAGES,

  // CHANGE POSITION PLACE IMAGES
  CHANGE_POSITION_PLACE_IMAGES,
  CHANGE_POSITION_PLACE_IMAGES_SUCCESS,
  CHANGE_POSITION_PLACE_IMAGES_FAILED,

  // DELETE IMAGES ROOMS FROM PLACE
  DELETE_IMAGES_ROOMS_FROM_PLACE,
  DELETE_IMAGES_ROOMS_FROM_PLACE_SUCCESS,
  DELETE_IMAGES_ROOMS_FROM_PLACE_FAILED,

  // EDIT CANCEL POLICY
  EDIT_CANCEL_POLICY,
  EDIT_CANCEL_POLICY_SUCCESS,
  EDIT_CANCEL_POLICY_FAILED,

  // UPDATE PLACE SERVICE FEE
  UPDATE_PLACE_SERVICE_FEE,
  UPDATE_PLACE_SERVICE_FEE_SUCCESS,
  UPDATE_PLACE_SERVICE_FEE_FAILED,

  // ADD PLACE OTHER FEE
  ADD_PLACE_OTHER_FEE,
  ADD_PLACE_OTHER_FEE_SUCCESS,
  ADD_PLACE_OTHER_FEE_FAILED,

  // UPDATE PLACE OTHER FEE
  UPDATE_PLACE_OTHER_FEE,
  UPDATE_PLACE_OTHER_FEE_SUCCESS,
  UPDATE_PLACE_OTHER_FEE_FAILED,

  // DELETE PLACE OTHER FEE
  DELETE_PLACE_OTHER_FEE,
  DELETE_PLACE_OTHER_FEE_SUCCESS,
  DELETE_PLACE_OTHER_FEE_FAILED,

  // EDIT POLICY RECEIVE ROOM
  EDIT_POLICY_RECEIVE_ROOM,
  EDIT_POLICY_RECEIVE_ROOM_SUCCESS,
  EDIT_POLICY_RECEIVE_ROOM_FAILED,

  // EDIT PLACE SERVICES EDIT
  EDIT_PLACE_SERVICES,
  EDIT_PLACE_SERVICES_SUCCESS,
  EDIT_PLACE_SERVICES_FAILED,

  // EDIT PLACE PARKING SERVICE
  EDIT_PLACE_PARKING_SERVICE,
  EDIT_PLACE_PARKING_SERVICE_SUCCESS,
  EDIT_PLACE_PARKING_SERVICE_FAILED,

  RESET_PLACE_DETAILS,

  // EDIT POLICY DEPOSIT
  EDIT_POLICY_DEPOSIT,
  EDIT_POLICY_DEPOSIT_SUCCESS,
  EDIT_POLICY_DEPOSIT_FAILED,

  // EDIT POLICY SMOKE AND PET
  EDIT_POLICY_SMOKE_AND_PET,
  EDIT_POLICY_SMOKE_AND_PET_SUCCESS,
  EDIT_POLICY_SMOKE_AND_PET_FAILED,

  // EDIT POLICY CURFEW
  EDIT_POLICY_CURFEW,
  EDIT_POLICY_CURFEW_SUCCESS,
  EDIT_POLICY_CURFEW_FAILED,

  // EDIT OTHER POLICY
  EDIT_OTHER_POLICY,
  EDIT_OTHER_POLICY_SUCCESS,
  EDIT_OTHER_POLICY_FAILED,

  // GET LIST ROOM OF PLACE
  GET_LIST_ROOM_OF_PLACE,
  GET_LIST_ROOM_OF_PLACE_SUCCESS,
  GET_LIST_ROOM_OF_PLACE_FAILED,

  // CLEAR LIST ROOM OF PLACE
  CLEAR_LIST_ROOM_OF_PLACE,

  // GET ROOM FACILITIES
  GET_ROOM_FACILITIES,
  GET_ROOM_FACILITIES_SUCCESS,
  GET_ROOM_FACILITIES_FAILED,

  // ADD ROOM FACILITIES
  ADD_ROOM_FACILITIES,
  ADD_ROOM_FACILITIES_SUCCESS,
  ADD_ROOM_FACILITIES_FAILED,

  // CREATE NEW PLACE
  CREATE_NEW_PLACE,
  CREATE_NEW_PLACE_SUCCESS,
  CREATE_NEW_PLACE_FAILED,

  // UPDATE NUMBER AVAILABLE ROOM
  UPDATE_NUMBER_AVAILABLE_ROOM,
  UPDATE_NUMBER_AVAILABLE_ROOM_SUCCESS,
  UPDATE_NUMBER_AVAILABLE_ROOM_FAILED,

  // ADD IMAGE TO PLACE PUBLIC IMAGES
  ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES,
  ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_SUCCESS,
  ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_FAILED,

  // DELETE IMAGE TO PLACE PUBLIC IMAGES
  DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES,
  DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_SUCCESS,
  DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_FAILED,

  // UPDATE PLACE VIDEO
  UPDATE_PLACE_VIDEO,
  UPDATE_PLACE_VIDEO_SUCCESS,
  UPDATE_PLACE_VIDEO_FAILED,

  // DELETE PLACE VIDEO
  DELETE_PLACE_VIDEO,
  DELETE_PLACE_VIDEO_SUCCESS,
  DELETE_PLACE_VIDEO_FAILED,

  // UPDATE CLOSE OPEN ROOM
  UPDATE_CLOSE_OPEN_ROOM,
  UPDATE_CLOSE_OPEN_ROOM_SUCCESS,
  UPDATE_CLOSE_OPEN_ROOM_FAILED,

  // UPDATE PRICE ROOM
  UPDATE_PRICE_ROOM,
  UPDATE_PRICE_ROOM_SUCCESS,
  UPDATE_PRICE_ROOM_FAILED,

  // GET PLACE PRICE TYPES
  GET_PLACE_PRICE_TYPES,
  GET_PLACE_PRICE_TYPES_SUCCESS,
  GET_PLACE_PRICE_TYPES_FAILED,

  // ADD PLACE PRICE TYPES
  ADD_PLACE_PRICE_TYPES,
  ADD_PLACE_PRICE_TYPES_SUCCESS,
  ADD_PLACE_PRICE_TYPES_FAILED,

  // DELETE PLACE PRICE TYPES
  DELETE_PLACE_PRICE_TYPES,
  DELETE_PLACE_PRICE_TYPES_SUCCESS,
  DELETE_PLACE_PRICE_TYPES_FAILED,

  // EDIT PLACE PRICE TYPES
  EDIT_PLACE_PRICE_TYPES,
  EDIT_PLACE_PRICE_TYPES_SUCCESS,
  EDIT_PLACE_PRICE_TYPES_FAILED,

  // UPDATE CHILDREN AND EXTRA BED POLICY
  UPDATE_CHILDREN_AND_EXTRA_BED_POLICY,
  UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_SUCCESS,
  UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_FAILED,

  // UPLOAD PLACE CONTRACT
  UPLOAD_PLACE_CONTRACT,
  UPLOAD_PLACE_CONTRACT_SUCCESS,
  UPLOAD_PLACE_CONTRACT_FAILED,

  // ADD PLACE FAVORITE
  ADD_PLACE_FAVORITE,
  ADD_PLACE_FAVORITE_SUCCESS,
  ADD_PLACE_FAVORITE_FAILED,

  // DELETE PLACE FAVORITE
  DELETE_PLACE_FAVORITE,
  DELETE_PLACE_FAVORITE_SUCCESS,
  DELETE_PLACE_FAVORITE_FAILED,
} from './actionTypes';

const initialState = {
  isLoadingGetGlobalPlaces: false,
  isLoadingGetMyPlace: false,
  isLoadingGetPlaceTodayBooking: false,
  isLoadingGetPlaceDetail: false,
  isLoadingUpdatePlace: false,
  isLoadingDeletePlace: false,
  isLoadingGetPlaceImages: false,
  isLoadingPostPlacePreviewImage: false,
  isLoadingPostPlaceImages: false,
  isLoadingEditPlaceService: false,
  isLoadingEditPlaceParkingService: false,
  isLoadingDeletePlaceImages: false,
  isLoadingPostImagesFromPlaceToRooms: false,
  isLoadingDeleteImagesRoomsFromPlace: false,
  isLoadingEditCancelPolicy: false,
  isLoadingUpdatePlaceServiceFee: false,
  isLoadingAddPlaceOtherFee: false,
  isLoadingUpdatePlaceOtherFee: false,
  isLoadingDeletePlaceOtherFee: false,
  isLoadingEditPolicyReceiveRoom: false,
  isLoadingEditPolicyCurfew: false,
  isLoadingEditOtherPolicy: false,
  isLoadingGetRoomOfPlaceList: false,
  isLoadingGetRoomFacilities: false,
  isLoadingAddRoomFacilities: false,
  isLoadingCreateNewPlace: false,
  isLoadingUpdateAvailableRoom: false,
  isLoadingAddImageToPublicImages: false,
  isLoadingUpdatePlaceVideo: false,
  isLoadingDeletePlaceVideo: false,
  isLoadingDeleteImageFromPublicImages: false,
  isLoadingUpdateCloseOpenRoom: false,
  isLoadingUpdatePriceRoom: false,
  isLoadingGetPlacePriceTypes: false,
  isLoadingAddPlacePriceTypes: false,
  isLoadingUpdateChildrenAndExtraBedPolicy: false,
  isLoadingUploadPlaceContract: false,
  isLoadingAddPlaceFavorite: false,
  isLoadingDeletePlaceFavorite: false,

  globalPlaces: [],
  globalPlacesTotal: 0,
  myPlace: [],
  placeTodayBooking: {
    todayCheckIn: [],
    todayCheckOut: [],
    todayBooking: [],
  },
  placePriceTypes: [],
  placeDetail: {},
  placeImageList: [],
  placeInformation: {},
  roomOfPlaceList: [],
  roomFacilities: {},
};

export default function place(state = initialState, action) {
  switch (action.type) {
    // GET GLOBAL PLACES
    case GET_GLOBAL_PLACES:
      return {
        ...state,
        isLoadingGetGlobalPlaces: true,
      };

    case GET_GLOBAL_PLACES_SUCCESS:
      return {
        ...state,
        isLoadingGetGlobalPlaces: false,
        globalPlaces: action.payload.data,
        globalPlacesTotal: action.payload.total,
      };

    case GET_GLOBAL_PLACES_FAILED:
      return {
        ...state,
        isLoadingGetGlobalPlaces: false,
      };

    // GET MY PLACE
    case GET_MY_PLACE:
      return {
        ...state,
        isLoadingGetMyPlace: true,
      };

    case GET_MY_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingGetMyPlace: false,
        myPlace: action.payload.data,
      };

    case GET_MY_PLACE_FAILED:
      return {
        ...state,
        isLoadingGetMyPlace: false,
      };

    // GET PLACE TODAY BOOKING
    case GET_PLACE_TODAY_BOOKING:
      return {
        ...state,
        isLoadingGetPlaceTodayBooking: true,
      };

    case GET_PLACE_TODAY_BOOKING_SUCCESS: {
      const data = action.payload || {};

      return {
        ...state,
        isLoadingGetPlaceTodayBooking: false,
        placeTodayBooking: {
          todayCheckIn: data.todayCheckIn || [],
          todayCheckOut: data.todayCheckOut || [],
          todayBooking: data.todayBooking || [],
        },
      };
    }

    case GET_PLACE_TODAY_BOOKING_FAILED:
      return {
        ...state,
        isLoadingGetPlaceTodayBooking: false,
        placeTodayBooking: {
          todayCheckIn: [],
          todayCheckOut: [],
          todayBooking: [],
        },
      };

    // GET PLACE DETAIL
    case GET_PLACE_DETAIL:
      return {
        ...state,
        isLoadingGetPlaceDetail: true,
      };

    case GET_PLACE_DETAIL_SUCCESS:
      return {
        ...state,
        isLoadingGetPlaceDetail: false,
        placeDetail: action.payload,
      };

    case GET_PLACE_DETAIL_FAILED:
      return {
        ...state,
        isLoadingGetPlaceDetail: false,
      };

    // CLEAR PLACE DETAIL
    case CLEAR_PLACE_DETAIL:
      return {
        ...state,
        placeDetail: {},
      };

    // UPDATE PLACE
    case UPDATE_PLACE:
      return {
        ...state,
        isLoadingUpdatePlace: true,
      };

    case UPDATE_PLACE_SUCCESS:
      return {
        ...state,
        placeDetail: {
          ...state.placeDetail,
          ...action.payload,
        },
        isLoadingUpdatePlace: false,
      };

    case UPDATE_PLACE_FAILED:
      return {
        ...state,
        isLoadingUpdatePlace: false,
      };

    // UPDATE PLACE PREVIEW IMAGE
    case POST_PLACE_PREVIEW_IMAGE:
      return {
        ...state,
        isLoadingPostPlacePreviewImage: true,
      };

    case POST_PLACE_PREVIEW_IMAGE_SUCCESS:
      return {
        ...state,
        isLoadingPostPlacePreviewImage: false,
      };

    case POST_PLACE_PREVIEW_IMAGE_FAILED:
      return {
        ...state,
        isLoadingPostPlacePreviewImage: false,
      };

    case GET_PLACE_IMAGES:
      return {
        ...state,
        isLoadingGetPlaceImages: true,
      };

    case GET_PLACE_IMAGES_SUCCESS:
      return {
        ...state,
        placeImageList: action.payload.images
          .map((item, index) => ({
            image: item,
            id: index + 1,
          }))
          .sort((a, b) => a.id - b.id),
        placeInformation: action.payload,
        isLoadingGetPlaceImages: false,
      };

    case GET_PLACE_IMAGES_FAILED:
      return {
        ...state,
        isLoadingGetPlaceImages: false,
      };

    case POST_PLACE_IMAGES:
      return {
        ...state,
        isLoadingPostPlaceImages: true,
      };

    case POST_PLACE_IMAGES_SUCCESS:
      return {
        ...state,
        isLoadingPostPlaceImages: false,
      };

    case POST_PLACE_IMAGES_FAILED:
      return {
        ...state,
        isLoadingPostPlaceImages: false,
      };

    case DELETE_PLACE_IMAGES:
      return {
        ...state,
        isLoadingGetPlaceImages: true,
      };

    case DELETE_PLACE_IMAGES_SUCCESS:
      return {
        ...state,
        isLoadingGetPlaceImages: false,
      };

    case DELETE_PLACE_IMAGES_FAILED:
      return {
        ...state,
        isLoadingGetPlaceImages: false,
      };

    case POST_IMAGES_FROM_PLACE_TO_ROOMS:
      return {
        ...state,
        isLoadingPostImagesFromPlaceToRooms: true,
      };

    case POST_IMAGES_FROM_PLACE_TO_ROOMS_SUCCESS:
      return {
        ...state,
        isLoadingPostImagesFromPlaceToRooms: false,
      };

    case POST_IMAGES_FROM_PLACE_TO_ROOMS_FAILED:
      return {
        ...state,
        isLoadingPostImagesFromPlaceToRooms: false,
      };

    case UPDATE_PLACE_IMAGES:
      return {
        ...state,
        placeImageList: action.payload,
      };

    case RESET_PLACE_IMAGES:
      return {
        ...state,
        placeImageList: [],
      };

    case CHANGE_POSITION_PLACE_IMAGES:
      return {
        ...state,
        isLoadingPostPlaceImages: true,
      };

    case CHANGE_POSITION_PLACE_IMAGES_SUCCESS:
      return {
        ...state,
        isLoadingPostPlaceImages: false,
      };

    case CHANGE_POSITION_PLACE_IMAGES_FAILED:
      return {
        ...state,
        isLoadingPostPlaceImages: false,
      };

      // DELETE IMAGES ROOMS FROM PLACE
    case DELETE_IMAGES_ROOMS_FROM_PLACE:
      return {
        ...state,
        isLoadingDeleteImagesRoomsFromPlace: true,
      };

    case DELETE_IMAGES_ROOMS_FROM_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingDeleteImagesRoomsFromPlace: false,
      };

    case DELETE_IMAGES_ROOMS_FROM_PLACE_FAILED:
      return {
        ...state,
        isLoadingDeleteImagesRoomsFromPlace: false,
      };

    // EDIT CANCEL POLICY
    case EDIT_CANCEL_POLICY:
      return {
        ...state,
        isLoadingEditCancelPolicy: true,
      };

    case EDIT_CANCEL_POLICY_SUCCESS:
      return {
        ...state,
        isLoadingEditCancelPolicy: false,
      };

    case EDIT_CANCEL_POLICY_FAILED:
      return {
        ...state,
        isLoadingEditCancelPolicy: false,
      };

    // UPDATE PLACE SERVICE FEE
    case UPDATE_PLACE_SERVICE_FEE:
      return {
        ...state,
        isLoadingUpdatePlaceServiceFee: true,
      };

    case UPDATE_PLACE_SERVICE_FEE_SUCCESS:
    case UPDATE_PLACE_SERVICE_FEE_FAILED:
      return {
        ...state,
        isLoadingUpdatePlaceServiceFee: false,
      };

    // ADD PLACE OTHER FEE
    case ADD_PLACE_OTHER_FEE:
      return {
        ...state,
        isLoadingAddPlaceOtherFee: true,
      };

    case ADD_PLACE_OTHER_FEE_SUCCESS:
    case ADD_PLACE_OTHER_FEE_FAILED:
      return {
        ...state,
        isLoadingAddPlaceOtherFee: false,
      };

    // UPDATE PLACE OTHER FEE
    case UPDATE_PLACE_OTHER_FEE:
      return {
        ...state,
        isLoadingUpdatePlaceOtherFee: true,
      };

    case UPDATE_PLACE_OTHER_FEE_SUCCESS:
    case UPDATE_PLACE_OTHER_FEE_FAILED:
      return {
        ...state,
        isLoadingUpdatePlaceOtherFee: false,
      };

    // DELETE PLACE OTHER FEE
    case DELETE_PLACE_OTHER_FEE:
      return {
        ...state,
        isLoadingDeletePlaceOtherFee: true,
      };

    case DELETE_PLACE_OTHER_FEE_SUCCESS:
    case DELETE_PLACE_OTHER_FEE_FAILED:
      return {
        ...state,
        isLoadingDeletePlaceOtherFee: false,
      };

    // EDIT POLICY RECEIVE ROOM
    case EDIT_POLICY_RECEIVE_ROOM:
      return {
        ...state,
        isLoadingEditReceiveRoomPolicy: true,
      };

    case EDIT_POLICY_RECEIVE_ROOM_SUCCESS:
      return {
        ...state,
        isLoadingEditReceiveRoomPolicy: false,
      };

    case EDIT_POLICY_RECEIVE_ROOM_FAILED:
      return {
        ...state,
        isLoadingEditReceiveRoomPolicy: false,
      };

    // RESET PLACE DETAILS
    case RESET_PLACE_DETAILS:
      return {
        ...state,
        placeDetail: {},
      };

    // EDIT PLACE SERVICES
    case EDIT_PLACE_SERVICES:
      return {
        ...state,
        isLoadingEditPlaceService: true,
      };

    case EDIT_PLACE_SERVICES_SUCCESS:
      return {
        ...state,
        isLoadingEditPlaceService: false,
      };

    case EDIT_PLACE_SERVICES_FAILED:
      return {
        ...state,
        isLoadingEditPlaceService: false,
      };

    // EDIT PLACE PARKING SERVICE
    case EDIT_PLACE_PARKING_SERVICE:
      return {
        ...state,
        isLoadingEditPlaceParkingService: true,
      };

    case EDIT_PLACE_PARKING_SERVICE_SUCCESS:
      return {
        ...state,
        isLoadingEditPlaceParkingService: false,
      };

    case EDIT_PLACE_PARKING_SERVICE_FAILED:
      return {
        ...state,
        isLoadingEditPlaceParkingService: false,
      };

    // EDIT POLICY DEPOSIT
    case EDIT_POLICY_DEPOSIT:
      return {
        ...state,
        isLoadingEditDepositPolicy: true,
      };

    case EDIT_POLICY_DEPOSIT_SUCCESS:
      return {
        ...state,
        isLoadingEditDepositPolicy: false,
      };

    case EDIT_POLICY_DEPOSIT_FAILED:
      return {
        ...state,
        isLoadingEditDepositPolicy: false,
      };

    // EDIT POLICY SMOKE AND PET
    case EDIT_POLICY_SMOKE_AND_PET:
      return {
        ...state,
        isLoadingEditDepositPolicy: true,
      };

    case EDIT_POLICY_SMOKE_AND_PET_SUCCESS:
      return {
        ...state,
        isLoadingEditDepositPolicy: false,
      };

    case EDIT_POLICY_SMOKE_AND_PET_FAILED:
      return {
        ...state,
        isLoadingEditDepositPolicy: false,
      };

    // EDIT POLICY CURFEW
    case EDIT_POLICY_CURFEW:
      return {
        ...state,
        isLoadingEditPolicyCurfew: true,
      };

    case EDIT_POLICY_CURFEW_SUCCESS:
      return {
        ...state,
        isLoadingEditPolicyCurfew: false,
      };

    case EDIT_POLICY_CURFEW_FAILED:
      return {
        ...state,
        isLoadingEditPolicyCurfew: false,
      };

    // EDIT OTHER POLICY
    case EDIT_OTHER_POLICY:
      return {
        ...state,
        isLoadingEditOtherPolicy: true,
      };

    case EDIT_OTHER_POLICY_SUCCESS:
      return {
        ...state,
        isLoadingEditOtherPolicy: false,
      };

    case EDIT_OTHER_POLICY_FAILED:
      return {
        ...state,
        isLoadingEditOtherPolicy: false,
      };

    // GET LIST ROOM OF PLACE
    case GET_LIST_ROOM_OF_PLACE:
      return {
        ...state,
        isLoadingGetRoomOfPlaceList: true,
      };

    case GET_LIST_ROOM_OF_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingGetRoomOfPlaceList: false,
        roomOfPlaceList: action.payload,
      };

    case GET_LIST_ROOM_OF_PLACE_FAILED:
      return {
        ...state,
        isLoadingGetRoomOfPlaceList: false,
      };

    // CLEAR LIST ROOM OF PLACE
    case CLEAR_LIST_ROOM_OF_PLACE:
      return {
        ...state,
        roomOfPlaceList: [],
      };

    // GET ROOM FACILITIES
    case GET_ROOM_FACILITIES:
      return {
        ...state,
        isLoadingGetRoomFacilities: true,
      };

    case GET_ROOM_FACILITIES_SUCCESS:
      return {
        ...state,
        isLoadingGetRoomFacilities: false,
        roomFacilities: action.payload,
      };

    case GET_ROOM_FACILITIES_FAILED:
      return {
        ...state,
        isLoadingGetRoomFacilities: false,
      };

    // ADD ROOM FACILITIES
    case ADD_ROOM_FACILITIES:
      return {
        ...state,
        isLoadingAddRoomFacilities: true,
      };

    case ADD_ROOM_FACILITIES_SUCCESS:
      return {
        ...state,
        isLoadingAddRoomFacilities: false,
      };

    case ADD_ROOM_FACILITIES_FAILED:
      return {
        ...state,
        isLoadingAddRoomFacilities: false,
      };

    // CREATE NEW PLACE
    case CREATE_NEW_PLACE:
      return {
        ...state,
        isLoadingCreateNewPlace: true,
      };

    case CREATE_NEW_PLACE_SUCCESS:
      return {
        ...state,
        isLoadingCreateNewPlace: false,
      };

    case CREATE_NEW_PLACE_FAILED:
      return {
        ...state,
        isLoadingCreateNewPlace: false,
      };

    // CREATE NEW PLACE
    case UPDATE_NUMBER_AVAILABLE_ROOM:
      return {
        ...state,
        isLoadingUpdateAvailableRoom: true,
      };

    case UPDATE_NUMBER_AVAILABLE_ROOM_SUCCESS:
      return {
        ...state,
        isLoadingUpdateAvailableRoom: false,
      };

    case UPDATE_NUMBER_AVAILABLE_ROOM_FAILED:
      return {
        ...state,
        isLoadingUpdateAvailableRoom: false,
      };

    // ADD IMAGE TO PLACE PUBLIC IMAGES
    case ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES:
      return {
        ...state,
        isLoadingAddImageToPublicImages: true,
      };

    case ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_SUCCESS:
      return {
        ...state,
        isLoadingAddImageToPublicImages: false,
      };

    case ADD_IMAGE_TO_PLACE_PUBLIC_IMAGES_FAILED:
      return {
        ...state,
        isLoadingAddImageToPublicImages: false,
      };

    // UPDATE PLACE VIDEO
    case UPDATE_PLACE_VIDEO:
      return {
        ...state,
        isLoadingUpdatePlaceVideo: true,
      };

    case UPDATE_PLACE_VIDEO_SUCCESS:
      return {
        ...state,
        isLoadingUpdatePlaceVideo: false,
      };

    case UPDATE_PLACE_VIDEO_FAILED:
      return {
        ...state,
        isLoadingUpdatePlaceVideo: false,
      };

    // DELETE PLACE VIDEO
    case DELETE_PLACE_VIDEO:
      return {
        ...state,
        isLoadingDeletePlaceVideo: true,
      };

    case DELETE_PLACE_VIDEO_SUCCESS:
      return {
        ...state,
        isLoadingDeletePlaceVideo: false,
      };

    case DELETE_PLACE_VIDEO_FAILED:
      return {
        ...state,
        isLoadingDeletePlaceVideo: false,
      };

    // DELETE IMAGE TO PLACE PUBLIC IMAGES
    case DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES:
      return {
        ...state,
        isLoadingDeleteImageFromPublicImages: true,
      };

    case DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_SUCCESS:
      return {
        ...state,
        isLoadingDeleteImageFromPublicImages: false,
      };

    case DELETE_IMAGE_FROM_PLACE_PUBLIC_IMAGES_FAILED:
      return {
        ...state,
        isLoadingDeleteImageFromPublicImages: false,
      };

    // UPDATE CLOSE OPEN ROOM
    case UPDATE_CLOSE_OPEN_ROOM:
      return {
        ...state,
        isLoadingUpdateCloseOpenRoom: true,
      };

    case UPDATE_CLOSE_OPEN_ROOM_SUCCESS:
      return {
        ...state,
        isLoadingUpdateCloseOpenRoom: false,
      };

    case UPDATE_CLOSE_OPEN_ROOM_FAILED:
      return {
        ...state,
        isLoadingUpdateCloseOpenRoom: false,
      };

    // UPDATE PRICE ROOM
    case UPDATE_PRICE_ROOM:
      return {
        ...state,
        isLoadingUpdatePriceRoom: true,
      };

    case UPDATE_PRICE_ROOM_SUCCESS:
      return {
        ...state,
        isLoadingUpdatePriceRoom: false,
      };

    case UPDATE_PRICE_ROOM_FAILED:
      return {
        ...state,
        isLoadingUpdatePriceRoom: false,
      };

    // GET PLACE PRICE TYPES
    case GET_PLACE_PRICE_TYPES:
      return {
        ...state,
        isLoadingGetPlacePriceType: true,
      };

    case GET_PLACE_PRICE_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingGetPlacePriceType: false,
        placePriceTypes: action.payload,
      };

    case GET_PLACE_PRICE_TYPES_FAILED:
      return {
        ...state,
        isLoadingGetPlacePriceType: false,
      };

    // ADD PLACE PRICE TYPES
    case ADD_PLACE_PRICE_TYPES:
      return {
        ...state,
        isLoadingAddPlacePriceTypes: true,
      };

    case ADD_PLACE_PRICE_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingAddPlacePriceTypes: false,
      };

    case ADD_PLACE_PRICE_TYPES_FAILED:
      return {
        ...state,
        isLoadingAddPlacePriceTypes: false,
      };

    // DELETE PLACE PRICE TYPES
    case DELETE_PLACE_PRICE_TYPES:
      return {
        ...state,
        isLoadingDeletePlacePriceTypes: true,
      };

    case DELETE_PLACE_PRICE_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingDeletePlacePriceTypes: false,
      };

    case DELETE_PLACE_PRICE_TYPES_FAILED:
      return {
        ...state,
        isLoadingDeletePlacePriceTypes: false,
      };

    // EDIT PLACE PRICE TYPES
    case EDIT_PLACE_PRICE_TYPES:
      return {
        ...state,
        isLoadingEditPlacePriceTypes: true,
      };

    case EDIT_PLACE_PRICE_TYPES_SUCCESS:
      return {
        ...state,
        isLoadingEditPlacePriceTypes: false,
      };

    case EDIT_PLACE_PRICE_TYPES_FAILED:
      return {
        ...state,
        isLoadingEditPlacePriceTypes: false,
      };

    // UPDATE CHILDREN AND EXTRA BED POLICY
    case UPDATE_CHILDREN_AND_EXTRA_BED_POLICY:
      return {
        ...state,
        isLoadingUpdateChildrenAndExtraBedPolicy: true,
      };

    case UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_SUCCESS:
      return {
        ...state,
        isLoadingUpdateChildrenAndExtraBedPolicy: false,
      };

    case UPDATE_CHILDREN_AND_EXTRA_BED_POLICY_FAILED:
      return {
        ...state,
        isLoadingUpdateChildrenAndExtraBedPolicy: false,
      };

    // UPLOAD PLACE CONTRACT
    case UPLOAD_PLACE_CONTRACT:
      return {
        ...state,
        isLoadingUploadPlaceContract: true,
      };

    case UPLOAD_PLACE_CONTRACT_SUCCESS:
      return {
        ...state,
        isLoadingUploadPlaceContract: false,
      };

    case UPLOAD_PLACE_CONTRACT_FAILED:
      return {
        ...state,
        isLoadingUploadPlaceContract: false,
      };

    // ADD PLACE FAVORITE
    case ADD_PLACE_FAVORITE:
      return {
        ...state,
        isLoadingAddPlaceFavorite: true,
      };

    case ADD_PLACE_FAVORITE_SUCCESS:
      return {
        ...state,
        isLoadingAddPlaceFavorite: false,
      };

    case ADD_PLACE_FAVORITE_FAILED:
      return {
        ...state,
        isLoadingAddPlaceFavorite: false,
      };

    // DELETE PLACE FAVORITE
    case DELETE_PLACE_FAVORITE:
      return {
        ...state,
        isLoadingDeletePlaceFavorite: true,
      };

    case DELETE_PLACE_FAVORITE_SUCCESS:
      return {
        ...state,
        isLoadingDeletePlaceFavorite: false,
      };

    case DELETE_PLACE_FAVORITE_FAILED:
      return {
        ...state,
        isLoadingDeletePlaceFavorite: false,
      };

    default:
      return state;
  }
}
